module.exports = __webpack_public_path__ + "static/img/icon2.c462bb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/dataCenter/icon2.png
// module id = hRqn
// module chunks = 1